import Details from '@/components/Details';
import RenderReportTable from '../ReportTable';
import { getClasses } from '@/utils';

export type ReportTableProps = {
  name: string;
  columns: any;
  rows: any;
  index: number;
  header?: any;
  footer?: any;
  onDetails?: (detailsObj: Record<string, unknown>) => void;
  condensed?: boolean;
  details?: Record<string, unknown>;
  filters?: Record<string, unknown>;
  reportType?: string;
};

const ReportTable = ({
  name,
  header,
  footer,
  columns,
  rows,
  index,
  onDetails,
  condensed,
  details,
  filters: tableFilters,
  reportType,
}: ReportTableProps): JSX.Element => {
  return (
    <div className={getClasses(condensed !== undefined && condensed !== false ? undefined : 'pt-4')}>
      {header && <Details data={Object.entries(header).map(([key, value]: any): any => ({ [key]: value }))} inline />}
      <RenderReportTable columns={columns} rows={rows} onDetails={onDetails} reportType={reportType} />
      {footer && <Details data={Object.entries(footer).map(([key, value]: any): any => ({ [key]: value }))} inline />}
    </div>
  );
};

export default ReportTable;
